// ======================
// AppDaemons
// ======================

import { observer } from "mobx-react-lite";
import { useAppServices } from "./services";
import { useEffect } from "react";
import { startPolling } from "../../common/poller/Poller";
import { isDevelopment } from "../../common/utils/util";
import { useEffectOnce } from "react-use";

interface AppDaemonsProps {}

export const AppDaemons: React.FC<AppDaemonsProps> = observer((props) => {
    const { appUpdateCheckerService, appGlobalService, authService } = useAppServices();

    useEffectOnce(() => {
        startPolling(
            () => appGlobalService.reloadEnabledFeatureFlags(),
            60 * 5,
            () => !authService.authenticated
        );
        startPolling(
            () => appUpdateCheckerService.reloadIfHashUpdated(),
            60,
            () => isDevelopment()
        );
    });

    return null;
});
